import React, { useState } from "react";
import styles from "./SopCard.module.css";
import Metadata from "../questionList/components/metaData/Metadata";
import QuestionAnswerSection from "../questionList/components/questionAnswerSection/QuestionAnswerSection";
import CustomButton, {
  ButtonType,
} from "../../../../../components/button/CustomButton";
import { useTranslation } from "react-i18next";
import { showConsoleError } from "../../../../../util/ConsoleMessage";
import { SopDataModel } from "../../../../../api/responsePayload/SopResponse";
import clsx from "clsx";
import {
  deleteSopKnowledge,
  editSopKnowledge,
} from "../../../../../api/SopApiCall";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/common/store";
import { useAppDispatch } from "../../../../../store/common/hooks";
import { fetchSopKnowledge } from "../../../../../store/sop.slice";

interface SopCardProps {
  data: SopDataModel;
}

const SopCard: React.FC<SopCardProps> = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const localData = data;
  const { currentPage } = useSelector((state: RootState) => state.pagination);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [description, setDescription] = useState<string>(data.description);
  const [content, setContent] = useState<string>(data.content);

  const handleReject = async () => {
    try {
      await deleteSopKnowledge(data.id);
      dispatch(fetchSopKnowledge({ page: currentPage }));
    } catch (e) {
      showConsoleError(e);
    }
  };

  const handleModify = async () => {
    if (content.trim() === "" || description.trim() === "") {
      return;
    }

    try {
      await editSopKnowledge(data.id, content, description);
      dispatch(fetchSopKnowledge({ page: currentPage }));
      setIsEditing(false);
    } catch (e) {
      showConsoleError(e);
    }
  };

  const onQuestionAnswerChanged = (
    newDescription: string,
    newContent: string
  ) => {
    setDescription(newDescription);
    setContent(newContent);
  };

  return (
    <div className={styles["question-group-scroll-container"]}>
      <div className={styles["question-group-container"]}>
        <div className={styles["question-group-main"]}>
          <div className={styles["question-container"]}>
            <Metadata text={`Id: ${localData.id}  `} />

            <div className={clsx(styles["title-view"])}>
              <div
                className={clsx(styles["title"], styles["label"])}
              >{`Title`}</div>
              <div className={clsx(styles["title"])}>{localData.title}</div>
            </div>
            <QuestionAnswerSection
              questionTitle={"Description"}
              answerTitle={"Content"}
              question={description}
              answer={content}
              color={"#fff"}
              classNameStyle={styles["remove-padding"]}
              openSelector={() => {}}
              isEditing={isEditing}
              isScreenShot={false}
              onChange={onQuestionAnswerChanged}
            />
            <div className={styles["buttons-container"]}>
              {!isEditing && (
                <CustomButton
                  text={t("newManager.reject")}
                  type={ButtonType.Reject}
                  onClick={handleReject}
                />
              )}

              {isEditing ? (
                <>
                  <CustomButton
                    text={t("newManager.exit_edit_mode")}
                    type={ButtonType.Cancel}
                    onClick={() => {
                      setIsEditing(false);
                      setDescription(data.description);
                      setContent(data.content);
                    }}
                  />

                  <CustomButton
                    type={ButtonType.Done}
                    text={"Save"}
                    onClick={handleModify}
                  />
                </>
              ) : (
                <CustomButton
                  type={ButtonType.Edit}
                  text={"Edit"}
                  onClick={() => setIsEditing(true)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SopCard;
